export interface MemberAbilityResource {
  type: 'MemberAbility'
  canUpdate: boolean
  canDelete: boolean
  canDeleteNonAuthoredMessages: boolean
  leader: boolean
  canReply: boolean
  canMessageAvailableMembers: boolean
  canArchive: boolean
  canUnarchive: boolean
}
